export const DELETE_USER_MODAL_ID = 'delete-user-modal';

export const USER_MENU_MODAL_ID = 'user-menu-modal';

export const NOTIFICATIONS_MODAL_ID = 'notifications-user-modal';
